// extracted by mini-css-extract-plugin
export default {"container":"PaymentGateway_container__0YhR4","backButton":"PaymentGateway_backButton__zjhC+"};